// extracted by mini-css-extract-plugin
export var headerCell = "_1a-1";
export var loadingSpinnerContainer = "_1a-4";
export var rowWrapper = "_1a-3";
export var standaloneTable = "_1a-5";
export var table = "_1a-0";
export var white = "_1a-2";